import { apiPlanning } from "src/common/apiUrl";
import { rest } from "src/common/rest";
import { ZUid } from "src/types/zUid";
import {
  ZBulkPlanCreation,
  zCheckBulkPlanCreation,
  ZCheckBulkPlanCreation,
} from "./BulkPlanCreationTypes";

export const checkBulkPlanCreation = async (
  objectServiceId: ZUid,
  entities: ZUid[],
): Promise<ZCheckBulkPlanCreation> => {
  const resp = await rest.post(
    apiPlanning(`/plan/${objectServiceId}/checkMassCreate`),
    entities,
  );
  return zCheckBulkPlanCreation.parse(resp.data);
};

export const bulkPlanCreate = async (
  objectServiceId: ZUid,
  data: ZBulkPlanCreation,
) => {
  await rest.post(apiPlanning(`/plan/${objectServiceId}/massCreate`), data);
};
